<template>
    <header
        v-editable="blok"
        class="weather-header"
        :style="{ '--header-image': `url(${image})` }"
    >
        <div class="weather-header__inner">
            <h1 class="weather-header__slogan">
                Weather in <br class="mobile">
                <span>{{ location }}</span>

                <WeatherMonth :provided-month="month" />
            </h1>

            <div class="weather-header__image">
                <div class="weather-header__widget">
                    <WeatherWidget :provided-month="month" />
                </div>
            </div>
        </div>
    </header>
</template>

<script setup>
import WeatherMonth from '~/storyblok/weather-header/weather-month.vue'
import WeatherWidget from '~/storyblok/weather-header/weather-widget.vue'
import './weather-header.scss'

defineProps({
    location: {
        type: String,
        required: false,
        default: 'Tanzania',
    },

    month: {
        type: Number,
        required: true,
    },

    image: {
        type: String,
        required: true,
    },
})
</script>
